import home from "@/page/home/home";
import NoPermission from "@/page/home/noPermission";
//活力魔方 => 自定义表单
import customFormList from "@/page/vibrantRubikCube/customForm/list";
import navigation from "@/page/vibrantRubikCube/runtime/navigation";
export default {
  home: home,
  NoPermission: NoPermission,
  customFormList: customFormList,
  navigation: navigation
};



// WEBPACK FOOTER //
// ./src/router/routersDetails.js